<template>
  <div class="user-menu">
    <div class="home" @click="goBridge" v-if="!isDemo">
      <div class="home__icon" />
      <span class="home__text">Home</span>
    </div>
    <div class="user-name" v-if="!isDemo">
      <span>{{ userData.userId }}</span>
      <router-link to="/tool/user/myinformation">
        <i class="icon icon--setting-size16"/>
      </router-link>
    </div>
    <ul>
      <li class="item__title" v-if="!isDemo">
        <span>Journey Map</span>
      </li>
      <template v-for="(item, index) in myInfoPage" >
        <li :key="`user-info-${index}`" v-if="!isDemo">
            <button class="item"
                    :class="{ disabled: item.disabled }"
                    @click="go({ name: item.name }, item.disabled)">
              {{ $t(`userInfo.lnb.${item.name}`) }}
            </button>
        </li>
      </template>
      <li class="item--common">
        <router-link to="/tool/user/jam" class="item item__link">{{ $t(`userInfo.lnb.jam`) }}</router-link>
      </li>
      <li class="" v-if="!isDemo">
        <router-link class="item" to="/tool/user/myinformation">
          {{ $t(`userInfo.lnb.myInformation`) }}
        </router-link>
      </li>
      <li class="divlist item--last" v-if="!isDemo">
        <div
          @click="go({ name: 'referrals' }, false)">
          {{ $t(`userInfo.lnb.referrals`) }}
        </div>
      </li>
      <li class="item__signout" :class="{noTop: isDemo}"><a href="#" class="item signout"
                                   @click.prevent="onSignOutClick">{{ $t('gnb.user.logout') }}</a></li>
      <li class="item__language">
        <span class="item item-language">{{ $t('gnb.user.language') }}</span>
        <div class="language--wrap"
             id="languageSelect"
             @mouseenter="resetDropdownTimer"
             @mouseleave="startDropdownTimer">
          <span class="current-language"
                @click.stop.prevent="showLanguageList(true)">
            <i class="icon icon--lang"
               :class="currentLocale"></i>
            {{ currentLocale.toUpperCase() }}
          </span>
          <i class="icon icon--drop-down"></i>
          <transition name="slide">
            <ul class="language__list" :class="{'is-show': showLanguageListStatus}" v-show="showLanguageListStatus">
              <li v-for="item in localeData" :key="item.code"
                  :class="{ [item.code]: true, on: item.code === currentLocale }"
                  :title="item.title"
                  @click="onLocaleClick(item.code)">
                <i class="icon icon--lang" :class="item.code"></i> {{ item.code.toUpperCase() }}
              </li>
            </ul>
          </transition>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { SIGNIN_LINK } from '@/libs/constants'
import { mapState, mapGetters } from 'vuex'
import { changeLocale } from '@/libs/i18n'
import { EventBus } from '@/libs/event-bus'

export default {
  name: 'UserMenu',
  computed: {
    ...mapState([
      'userData',
      'planData',
      'showUserMenu',
      'isDemo'
    ]),
    ...mapGetters([
      'creditData'
    ]),
    currentLocale () {
      return this.$i18n.locale
    },
    myInfoPage () {
      return [
        {
          name: 'managePlan'
        },
        {
          name: 'billing'
        },
        {
          name: 'ipBlocking'
        }
      ]
    }
  },
  data () {
    return {
      showLanguageListStatus: false,
      dropdownTimer: null,
      dropdownTimerTime: null,
      animating: false
    }
  },
  created () {
    this.localeData = [
      {
        code: 'ja',
        title: 'Japanese'
      },
      {
        code: 'en',
        title: 'English'
      },
      {
        code: 'ko',
        title: 'Korean'
      }
    ]
  },
  mounted () {
    EventBus.$on('closeUserMenu', () => {
      this.showLanguageListStatus = false
    })
  },
  watch: {
    showLanguageListStatus (value) {
      let bodyListener = (e) => {
        let outside = true

        function composedPath (el) {
          let paths = []
          while (el) {
            paths.push(el)
            if (el.tagName === 'HTML') {
              paths.push(document)
              paths.push(window)
              return paths
            }
            el = el.parentElement
          }
        }

        const path = e.path || (e.composedPath && e.composedPath()) || composedPath(e.target)
        if (path) {
          for (const el of path) {
            if (el.id && el.id === 'languageSelect') {
              outside = false
            }
          }
        }
        if (outside) {
          this.showLanguageListStatus = false
        }
      }

      if (value) {
        document.body.addEventListener('click', bodyListener, false)
      } else {
        document.body.removeEventListener('click', bodyListener)
      }
    }
  },
  methods: {
    startDropdownTimer: function () {
      this.dropdownTimer = setInterval(() => {
        if (this.dropdownTimerTime < 3) {
          this.showLanguageListStatus = false
        }
        this.dropdownTimerTime--
      }, 1000)
    },
    resetDropdownTimer: function () {
      this.dropdownTimerTime = 3
      clearInterval(this.dropdownTimer)
      this.dropdownTimer = null
    },
    go (params, stop) {
      if (params.name !== this.$route.name && !stop) {
        EventBus.$emit('onLoading', true, 'user-menu')
        setTimeout(() => {
          this.$router.push(params)
        }, this.$route.path.includes('user') ? 300 : 0)
      }
    },
    onLocaleClick (locale) {
      changeLocale(this.$i18n, locale)
    },
    showLanguageList (status) {
      status ? this.showLanguageListStatus = true : this.showLanguageListStatus = false
    },
    onSignOutClick () {
      this.$root.$children[0].signOut()
      window.location.href = SIGNIN_LINK
    },
    goBridge () {
      window.location.href = SIGNIN_LINK.replace('signin', 'my')
    }
  }
}
</script>

<style lang="scss" scoped>
.user-menu {
  position: absolute;
  top: 34px;
  right: 0;
  z-index: 10000001;
  width: 220px;
  border-radius: 14px;
  box-shadow: 0 16px 15px -4px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding-bottom: 12px;
  transform-origin: top;

    .home {
      display: flex;
      align-items: center;
      column-gap: 5px;

      padding-top: 15px;
      padding-left: 20px;

      cursor: pointer;

      &__icon {
        box-sizing: border-box;
        width: 34px;
        height: 34px;
        padding: 9px;
        border-radius: 20px;
        border: solid 1px #bbb;
        background: url(../../assets/img/icon-home.svg) no-repeat center center;
        background-color: #fff;
      }

      &__text {
        font-size: 14px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1;
        letter-spacing: normal;
        color: #2f2f2f;
      }
    }

  .user-name {
    display: flex;
    column-gap: 5px;
    padding-top: 15px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 12px;

    span {
      word-break: break-all;
      max-width: 100%;
      color: #3096a7;
      font-size: 13px;
      font-weight: 600;
      text-overflow: ellipsis;
      overflow: hidden;
      box-sizing: border-box;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      line-height: 1.62;
    }

    .icon--setting-size16 {
      margin-top: 2.5px;
    }
  }

  & > ul {
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;

    li {
      padding: 7px 10px;
      box-sizing: border-box;
      position: relative;
      background-color: #ffffff;

      &.item__title {
        height: auto;
        padding-top: 20px;
        border-top: 1px solid #d7d7d7;

        font-size: 12px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: #999;
      }

      &.item__signout {
        height: auto;
        padding-top: 15px;
        padding-bottom: 0;
        border-top: 1px solid #d7d7d7;

        &.noTop {
          border-top: none;
        }
      }

      &.item__language {
        display: flex;
        align-items: center;
        height: 50px;
        padding: 12px 0px 0px 0px;
      }

      &.divlist {
        padding: 0px 10px;
      }

      .item {
        display: inline-block;
        width: 100%;
        height: 27px;
        line-height: 27px;
        font-size: 14px;
        color: #2f2f2f;
        padding-left: 10px;
        box-sizing: border-box;
        border-radius: 12px;
        text-align: left;
        transition: background-color 0.2s ease;

        &.disabled {
          cursor: default;
          opacity: 0.4;
        }
      }

      &:hover .item:not(.item-language):not(.disabled):not(.signout) {
        background-color: #ebebeb;
      }

      &.item--common {
        padding: 0px;
        padding-top: 7px;
        margin: 7px 10px;
        border-top: 1px dashed #d1d1d1;
      }

      &.item--last {
        margin-bottom: 7px;
      }

      .signout {
        display: block;
        margin: 0 auto;
        width: 180px;
        height: 34px;
        border-radius: 20px;
        border: solid 1px #bbbbbb;
        background-color: #ffffff;
        padding-left: 0;
        text-align: center;
        line-height: 32px;
      }

      .language--wrap {
        position: absolute;
        top: 12px;
        right: 0;
        width: 98px;
        height: 38px;
        border-radius: 6px;
        border: solid 1px #bbbbbb;
        background-color: #ffffff;
        box-sizing: border-box;

        .current-language {
          position: absolute;
          top: 0;
          left: 0;
          display: inline-block;
          width: 100%;
          height: 100%;
          line-height: 36px;
          padding-left: 6px;
          box-sizing: border-box;

          font-size: 14px;
          color: #2f2f2f;
          cursor: pointer;
          .icon--lang {
            vertical-align: middle;
            margin-right: 5px;
            position: relative;
            top: -1px;
          }
        }
        .language__list li{
          display: inline-block;
          width: 100%;
          height: 100%;
          line-height: 36px;
          padding-left: 6px;
          box-sizing: border-box;

          font-size: 14px;
          color: #2f2f2f;
          cursor: pointer;

          .icon--lang {
            vertical-align: middle;
            margin-right: 5px;
            position: relative;
            top: -1px;
          }
        }

        .language__list {
          width: 98px;
          border-radius: 6px;
          box-shadow: 0 23px 15px -12px rgba(0, 0, 0, 0.08), 0 0 0 1px rgba(0, 0, 0, 0.25);
          background-color: #ffffff;
          overflow: hidden;
          position: absolute;
          top: -1px;
          left: -1px;
          z-index: 1;

          opacity: 0;
          transform-origin: top;
          transition: transform .2s ease, opacity .1s ease;

          &.is-show {
            opacity: 1;
          }

          li {
            transition: background-color 0.2s ease;

            &:hover {
              background-color: #ebebeb;
            }
          }
        }

        .icon--drop-down {
          pointer-events: none;
          position: absolute;
          top: 50%;
          right: 12px;
          transform: translateY(-50%);
        }
      }

      div {
        padding-left: 13px;
        color: #444444;
        border-radius: 20px;
        cursor: pointer;
        font-size: 13px;
        height: 27px;
        line-height: 27px;
        &:hover {
          background-color: #ebebeb;
        }
      }
      div::before {
        content: "•";
        color: #999999;
      }
    }
  }
}

.slide-enter, .slide-leave-to{
  transform: scaleY(0);
  opacity: 0;
}
</style>
